import { BookOpen, Download, FileText, Search, Settings } from 'lucide-react';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { Input } from '../../components/ui/input';

const documentos = [
  { id: 1, titulo: 'Revista CAO - Edición Actual', tipo: 'Revista', año: '2026', formato: 'PDF' },
  { id: 2, titulo: 'Guías Clínicas de Oftalmología', tipo: 'Guía', año: '2025', formato: 'PDF' },
  { id: 3, titulo: 'Archivo Histórico CAO', tipo: 'Colección', año: '1950-2024', formato: 'Digital' },
  { id: 4, titulo: 'Tesis y Trabajos Científicos', tipo: 'Repositorio', año: '2024', formato: 'PDF' },
  { id: 5, titulo: 'Protocolos de Atención', tipo: 'Documento', año: '2025', formato: 'PDF' },
];

const Biblioteca = () => {
  return (
    <div className="space-y-6">
      <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
        <div className="flex items-center gap-3">
          <Settings className="w-5 h-5 text-amber-600" />
          <div>
            <p className="font-medium text-amber-800">Módulo en configuración</p>
            <p className="text-sm text-amber-600">Biblioteca Digital estará disponible próximamente. A continuación se muestra una vista previa.</p>
          </div>
        </div>
      </div>

      <div className="opacity-50 pointer-events-none select-none">
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-gray-500 mb-2">Biblioteca Digital</h1>
          <p className="text-gray-400">Acceso a publicaciones, revistas y documentos</p>
        </div>

        <div className="relative mb-6">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
          <Input placeholder="Buscar documentos..." className="pl-10 bg-gray-100" disabled />
        </div>

        <div className="space-y-3">
          {documentos.map((doc) => (
            <Card key={doc.id} className="bg-gray-50 border-gray-200">
              <CardContent className="p-4">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4">
                    <div className="p-3 bg-gray-200 rounded-lg">
                      <FileText className="w-6 h-6 text-gray-400" />
                    </div>
                    <div>
                      <h3 className="font-medium text-gray-500">{doc.titulo}</h3>
                      <div className="flex gap-2 mt-1">
                        <Badge className="bg-gray-300 text-gray-600 text-xs">{doc.tipo}</Badge>
                        <span className="text-xs text-gray-400">{doc.año}</span>
                        <span className="text-xs text-gray-400">{doc.formato}</span>
                      </div>
                    </div>
                  </div>
                  <Button variant="outline" className="text-gray-400 border-gray-300" disabled>
                    <Download className="w-4 h-4 mr-2" /> Descargar
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Biblioteca;
